import { handleScroll } from './handle-scroll'



( function ( $ ) {

    $('.submenu-item').on('click', function(){
        let checkbox = $('.m-menu__checkbox')[0];
        checkbox.checked = !checkbox.checked;
        handleScroll();
    })

} )( jQuery );